<template>
  <div class="phenotype-disease-network-page col-block width-full" :style="{ flex: 1 }">
    <div class="phenotype-disease-network-list-container col-block width-full">
      <div class="phenotype-disease-network-container row-block flex-start" v-for="(hpo, hpoID, hindex) in hpoNetworks" :key="hindex">
        <div class="phenotype-disease-network-path-container row-block" :style="{ width: '220px' }">
          <template v-if="hpo.path">
            <div class="phenotype-disease-network-path-title ellipsis" :title="hpo.path[hpo.path.length - 1].name" :style="{ flex: 1 }">{{ hpo.path[hpo.path.length - 1].name }}</div>
            <a class="phenotype-disease-network-path-icon icon-block" :href="hpo.path[hpo.path.length - 1].url" :style="{ '--size': '12px' }" target="_blank">
              <img :src="require('../../assets/icons/external-link-icon.svg')" alt="">
            </a>
          </template>
        </div>
        <div class="phenotype-disease-network-icon-container row-block">
          <pathIcon
            :paths="hpo.path || (hpo.result === 'no_hit' ? null : [])"
            :borCorType="borCorType"
          ></pathIcon>
        </div>
        <div class="phenotype-disease-network-hpo-container row-block" :style="{ flex: 1, width: 0 }">
          <div class="phenotype-disease-network-path-title shrink ellipsis" :title="hpo.name">{{ hpo.name }}</div>
          <a class="phenotype-disease-network-path-icon icon-block" :href="hpo.url" :style="{ '--size': '12px' }" target="_blank">
            <img :src="require('../../assets/icons/external-link-icon.svg')" alt="">
          </a>
          <div :style="{ flex: 1 }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pathIcon from './pathIcon.vue'

export default {
  components: {
    pathIcon
  },
  props: {
    hpoNetworks: {
      type: Object,
      required: true
    },
    borCorType: {
      type: String,
      default: () => 'bottom'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/phenotypeDisease/network.vue